/** 18 px purple pill, "9+" above 9. Red stays for errors only. */
export function UnreadPill({
  count,
  className = '',
}: {
  count: number;
  className?: string;
}) {
  if (count <= 0) return null;
  return (
    <span
      className={`h-[18px] min-w-[18px] shrink-0 rounded-full bg-primary-600 px-1.5 text-center text-[11px] font-semibold leading-[18px] text-primary-foreground ${className}`.trim()}
    >
      {count > 9 ? '9+' : count}
    </span>
  );
}
